import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Paragraph from '../Text/Paragraph';
var ComboboxEmptyState = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Paragraph, _extends({
    ref: ref
  }, props));
});
ComboboxEmptyState.displayName = 'ComboboxEmptyState';
ComboboxEmptyState.defaultProps = {
  paddingX: 'sm',
  paddingY: 1.5,
  fontColor: 'textMedium',
  children: 'No matches found.'
};
export default ComboboxEmptyState;